import { useStatsigClient } from '@statsig/react-bindings';

import { STATSIG_GATE } from './constants';

export interface GateResult {
  value: boolean;
  isReady: boolean;
  reason?: string;
}

export function useStatsigGate(gateName: string): GateResult {
  const { client } = useStatsigClient();
  const isReady = client?.loadingStatus === 'Ready';

  if (!isReady || client == null) {
    return { value: false, isReady: false };
  }

  const value = client.checkGate(gateName);
  return { value, isReady: true, reason: 'Network:Recognized' };
}

export function useDeclineUiActionsGate(): GateResult {
  return useStatsigGate(STATSIG_GATE.DECLINE_UI_ACTIONS);
}

export function usePriceCalloutGate(): GateResult {
  return useStatsigGate(STATSIG_GATE.PRICE_CALLOUT);
}
